import React, { useEffect, useState } from "react";
import { getPgDetails, getPgDetailsByOwner } from "./apiService";
import "../css/dashboard.css";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";

const MyPGDetails = () => {
  const [pgdetails, setPgdetails] = useState([]);
  const navigate = useNavigate();
  const { userid, pgId, Rcount } = useAuth();

  useEffect(() => {
    getPgDetailsByOwner(userid).then((res) => {
      setPgdetails(res);
      // console.log(pgdetails);
    });
  }, [userid]);

  const handleSelect = (pg) => {
    // console.log(pg);
    pgId(pg.id);
    navigate("RoomDetails");
  };
  const handleEdit = (pg) => {
    // console.log(pg);
    pgId(pg.id);
    navigate("EditPG");
  };

  const handleCreateNewRoom = (pg) => {
    pgId(pg.id);
    Rcount(pg.rooms);
    navigate("NewRoom");
  };

  return (
    <div>
      <div className="container-box">
        <h3 className="header">PG Details</h3>
        <table>
          <thead>
            <tr>
              <th>PG NAME</th>
              <th>TOTAL ROOMS</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {pgdetails.map((pg) => {
              if (pg.owner === userid) {
                return (
                  <tr key={pg.id}>
                    <td>{pg.pgname}</td>
                    <td>{pg.rooms}</td>
                    <td>
                      <button onClick={() => handleEdit(pg)}>Edit PG</button>
                      <button onClick={() => handleCreateNewRoom(pg)}>
                        NewRoom
                      </button>
                      <button onClick={() => handleSelect(pg)}>
                        RoomsList
                      </button>
                    </td>
                  </tr>
                );
              }
              return null;
            })}
          </tbody>
        </table>
      </div>
      <Outlet />
    </div>
  );
};

export default MyPGDetails;
